import { __awaiter, __generator } from "tslib";
import { multinetAxiosInstance } from './axios';
export function validTableUploadType(type) {
    return type === 'csv';
}
export function validNetworkUploadType(type) {
    return ['nested_json', 'newick', 'd3_json'].includes(type);
}
export function validUploadType(type) {
    return validTableUploadType(type) || validNetworkUploadType(type);
}
var MultinetAPI = /** @class */ (function () {
    function MultinetAPI(baseURL) {
        this.axios = multinetAxiosInstance({ baseURL: baseURL });
    }
    MultinetAPI.prototype.logout = function () {
        this.axios.logout();
    };
    MultinetAPI.prototype.userInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.userInfo()];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.workspaces = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.workspaces()];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.getWorkspacePermissions = function (workspace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!workspace) {
                            throw new Error('argument "workspace" must not be empty');
                        }
                        return [4 /*yield*/, this.axios.getWorkspacePermissions(workspace)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.getCurrentUserWorkspacePermissions = function (workspace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!workspace) {
                            throw new Error('argument "workspace" must not be empty');
                        }
                        return [4 /*yield*/, this.axios.getCurrentUserWorkspacePermissions(workspace)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.setWorkspacePermissions = function (workspace, permissions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!workspace) {
                            throw new Error('argument "workspace" must not be empty');
                        }
                        return [4 /*yield*/, this.axios.setWorkspacePermissions(workspace, permissions)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.searchUsers = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.searchUsers(username)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.tables = function (workspace, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.tables(workspace, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.table = function (workspace, table, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.table(workspace, table, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.networks = function (workspace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.networks(workspace)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.network = function (workspace, network) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.network(workspace, network)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.nodes = function (workspace, network, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.nodes(workspace, network, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.edges = function (workspace, network, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.edges(workspace, network, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.networkTables = function (workspace, network, type) {
        if (type === void 0) { type = 'all'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.networkTables(workspace, network, type)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.createWorkspace = function (workspace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.createWorkspace(workspace)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.deleteWorkspace = function (workspace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.deleteWorkspace(workspace)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.renameWorkspace = function (workspace, name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.renameWorkspace(workspace, name)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.uploadTable = function (workspace, table, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.uploadTable(workspace, table, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.downloadTable = function (workspace, table) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.downloadTable(workspace, table)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.deleteTable = function (workspace, table) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.deleteTable(workspace, table)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.columnTypes = function (workspace, table) {
        return __awaiter(this, void 0, void 0, function () {
            var types;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.columnTypes(workspace, table)];
                    case 1:
                        types = (_a.sent()).data;
                        return [2 /*return*/, types];
                }
            });
        });
    };
    MultinetAPI.prototype.uploadNetwork = function (workspace, network, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.uploadNetwork(workspace, network, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.createNetwork = function (workspace, network, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.createNetwork(workspace, network, options)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.deleteNetwork = function (workspace, network) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.deleteNetwork(workspace, network)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.aql = function (workspace, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.aql(workspace, query)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.createAQLTable = function (workspace, table, query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.createAQLTable(workspace, table, query)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    MultinetAPI.prototype.downloadNetwork = function (workspace, network) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.downloadNetwork(workspace, network)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    };
    return MultinetAPI;
}());
export function multinetApi(baseURL) {
    return new MultinetAPI(baseURL);
}
//# sourceMappingURL=index.js.map